import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToMysqlDateTime } from "../../inc/helper";

import ReactPaginate from "react-paginate";

class AuctionMemberOffersModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctionMemberOffers: [],
      auctionVehicle: {},

      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10,
    };
  }

  componentDidMount() {
    this.getAuctionMemberOffers();
    this.getAuctionVehicle()
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getAuctionMemberOffers(currentPage) {
    let sessionHash = getCookie("sessionHash");

    const requestOptions = {
      method: "GET",
      headers: { Authorization: "Bearer " + sessionHash },
    };

    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;

    fetch(config.restApi + `auctionMemberOffers/tr?filterAuctionItemId=${this.props.searchParams.get('auctionItemId')}&limit=${this.state.limit}&page=${currentPage}`, requestOptions)
    .then((response) => response.json())
    .then(
      (responseData) => {
        switch (responseData.status) {
          case 200:
            const currentAuctionMemberOffers = responseData.auctionMemberOffers.slice(startIndex, endIndex);
            this.setState({isLoading: false, auctionMemberOffers: currentAuctionMemberOffers, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
          break;
          case 401:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(this.props.navigate('/home'))
          break;
          default:
            swal({
              dangerMode: true,
              icon: "warning",
              title: "Hay Aksi",
              text: responseData.message,
              buttons: "Tamam",
            });
            break;
        }
      },
      () =>
        swal({
          dangerMode: true,
          icon: "error",
          title: "Bağlantı Hatası",
          text: "Lütfen internet bağlantınızı kontrol ediniz.",
          buttons: "Tamam",
        })
    );
  }

  getAuctionVehicle() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + `auctionVehicle/tr/${this.props.searchParams.get('auctionVehicleId')}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false, auctionVehicle: responseData.auctionVehicleInfo});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  priceFormat = (value) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  handlePageClick(page) {
    this.setState({currentPage: page.selected + 1}, () => this.getAuctionMemberOffers(this.state.currentPage))
  }

  render() {

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col-12">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between pr-3">
              <strong className="text-black">Teklifler</strong>
              <div className="d-flex">
                <button className="btn btn-darkblue text-white mr-1" onClick={() => this.props.navigate(-1)} title="Geri"><i className="fa fa-reply"></i></button>
              </div>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>Araç Adı</th>
                    <th>Araç Markası</th>
                    <th>Satış Durumu</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="align-middle">{this.state.auctionVehicle.title}<br />Araç No #:{this.state.auctionVehicle.id}</td>
                    <td className="align-middle">{this.state.auctionVehicle.vehicleBrandName} - {this.state.auctionVehicle.vehicleModelName} <br />{this.state.auctionVehicle.vehicleEquipmentName} {this.state.auctionVehicle.year > 0 && "- " + this.state.auctionVehicle.year}</td>
                    <td className="align-middle">{this.state.auctionVehicle.soldStatus === 0 ? 'Satılmadı' : 'Satıldı'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>Teklif Veren</th>
                    <th>Teklif Zamanı</th>
                    <th>Teklif Fiyatı</th>
                    <th>Satış Durumu</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.auctionMemberOffers.map((auctionMemberOffer, index) =>
                  <tr key={index}>
                    <td className="align-middle">{auctionMemberOffer.memberFullName}<br />Üye No #:{auctionMemberOffer.memberId}</td>
                    <td className="align-middle">{isoToMysqlDateTime(auctionMemberOffer.offerDate)}</td>
                    <td className="align-middle">{this.priceFormat(auctionMemberOffer.offerPrice)} ₺</td>
                    <td className="align-middle">{auctionMemberOffer.auctionVehicleSoldStatus === 0 ? 'Satılmadı' : 'Satıldı'}</td>
                  </tr>
                  )}
                  {this.state.auctionMemberOffers.length === 0 && <tr><td className="align-middle text-darkblue p-3" colSpan="4">Teklif Bulunamadı !</td></tr>}
                </tbody>
              </table>
            </div>
            {this.state.auctionMemberOffers.length !== 0 &&
              <ReactPaginate
                previousLabel={"Geri"}
                nextLabel={"İleri"}
                breakLabel={"..."}  
                pageCount={this.state.pageCount}
                marginPagesDisplayed={1}
                onPageChange={page => this.handlePageClick(page)}
                pageRangeDisplayed={2}
                containerClassName={'pagination'}
                activeClassName={'activePage'}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionMemberOffers(props) {
  return (
    <AuctionMemberOffersModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionMemberOffersModule>
  );
}
